import { ClickAwayListener, Grid, GridProps, makeStyles, Radio } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import { ReactComponent as ArrowDown } from 'assets/svg/arrowDown.svg';
import { ReactComponent as ArrowUp } from 'assets/svg/arrowUp.svg';
import { ReactComponent as CheckedIcon } from 'assets/svg/checkboxChecked.svg';
import { ReactComponent as UnCheckedIcon } from 'assets/svg/unCheck.svg';
import { ReactComponent as CloseTagIcon } from 'assets/svg/closeTag.svg';
import clsx from 'clsx';
import React, { useEffect, useMemo, useState } from 'react';
import themes from 'styles/themes';
interface ISelectMultipleDropDown {
    listSelectedValue: any[] | string;
    children: JSX.Element[];
    placeholder: string;
    onChange: (value: any) => void;
    error?: any;
    anchorId?: string;
    isSingle?: boolean;
    isSelectedTag?: boolean;
    disable?: boolean;
    isBadgeDropdown?: boolean;
}

interface ISelectOption {
    value: any;
    label: string;
    descriptions?: string[];
}

interface ISelectedTag {
    item: ISelectOption;
    handleDeleteItem: any;
}

interface IStyledSelectOption extends ISelectOption, GridProps {
    isActive: boolean;
    handleChange: (value: any) => void;
    isSingle?: boolean;
    hideAction?: boolean;
}

const useStyles = makeStyles(() => ({
    input: {
        color: themes.palette.primary.main,
        border: 'none!important',
        width: '90%',
        textOverflow: 'ellipsis',
        margin: '6px 0',
        padding: '0',
        opacity: '1 !important',
        fontFamily: 'PoppinsRegular',
        '&::placeholder': {
            fontFamily: 'PoppinsRegular',
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '24px',
            color: themes.palette.primary.main,
            opacity: 0.5,
        },
    },
    inputError: {
        '&::placeholder': {
            color: 'red !important',
        },
    },
    optionWrapper: {
        width: '100%',
        maxHeight: '200px',
        overflowY: 'scroll',
        background: '#fff',
        position: 'absolute',
        zIndex: 100,
        top: '110%',
        borderRadius: '10px',
        padding: '10px',
        visibility: 'visible',
        // opacity: 1,
    },
    optionWrapperBadge: {
        width: '100%',
        maxHeight: '200px',
        overflowY: 'scroll',
        background: '#fff',
        position: 'absolute',
        zIndex: 1,
        top: '110%',
        borderRadius: '10px',
        padding: 2,
        visibility: 'visible',
    },
    optionWrapperTransition: {
        // transition: "all 0.5s ease",
    },
    optionWrapperHide: {
        // transform: "translateY(0)",
        // opacity: "0",
        visibility: 'hidden',
        maxHeight: '0px',
        display: 'none',
    },
    selectIcon: {
        position: 'absolute',
        right: '10px',
        top: '50%',
    },
    inputCheckbox: {
        color: themes.palette.primary.main,
        border: 'none!important',
        width: '100%',
        textOverflow: 'ellipsis',
        margin: '6px 0',
        padding: '0',
        opacity: '1 !important',
        display: 'flex',
        flexWrap: 'wrap',
        minHeight: '20px',
        '&::placeholder': {
            fontFamily: 'PoppinsRegular',
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '24px',
            color: themes.palette.primary.main,
            opacity: 0.5,
        },
    },
}));

const useSelectOptionStyles = makeStyles(() => ({
    alignCenter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    selectContent: {
        justifyContent: 'flex-start',
        fontFamily: 'PoppinsRegular',
        fontStyle: 'normal',
        fontSize: '16px',
        color: themes.palette.primary.main,
        paddingLeft: 8,
    },
    item: {
        padding: '10px',
        cursor: 'pointer',
        '&:hover': {
            background: themes.palette.secondary['500'],
            borderRadius: '4px',
        },
    },
    radioChecked: {
        color: themes.palette.primary.main,
    },
}));
const useSelectedTagStyles = makeStyles(() => ({
    itemTag: {
        background: themes.palette.primary.main,
        height: '28px',
        borderRadius: '4px',
        display: 'flex',
        width: 'fit-content',
        padding: '0 4px',
        margin: '5px',
        alignItems: 'center',
        color: themes.palette.common.white,
    },
}));

export const StyledSelectBadgeWithDesc = (props: IStyledSelectOption) => {
    const classes = useSelectOptionStyles();
    const { handleChange, label, value, descriptions, ...rest } = props;
    return (
        <Grid
            container
            className={classes.item}
            onClick={() => {
                handleChange(value);
            }}
            style={rest.style}
        >
            <Grid
                item
                xs={11}
                xl={11}
                sm={11}
                md={11}
                lg={11}
                className={clsx(classes.alignCenter, classes.selectContent)}
            >
                <p
                    style={{
                        backgroundColor: themes.palette.primary.main,
                        width: 'auto',
                        borderRadius: 4,
                        padding: '4px 6px',
                        color: themes.palette.common.white,
                    }}
                    className="d-flex flex-row"
                >
                    {label}
                </p>
            </Grid>
            {Boolean(descriptions?.length) && (
                <Grid
                    item
                    xs={11}
                    xl={11}
                    sm={11}
                    md={11}
                    lg={11}
                    className={clsx(classes.alignCenter, classes.selectContent)}
                >
                    {descriptions![0]}
                </Grid>
            )}
        </Grid>
    );
};

export const StyledSelectOption = (props: IStyledSelectOption) => {
    const classes = useSelectOptionStyles();
    const { handleChange, label, value, isActive, isSingle, descriptions, ...rest } = props;
    return (
        <Grid
            container
            className={classes.item}
            onClick={() => {
                handleChange(value);
            }}
            style={rest.style}
        >
            <Grid
                item
                xs={11}
                xl={11}
                sm={11}
                md={11}
                lg={11}
                className={clsx(classes.alignCenter, classes.selectContent)}
            >
                {label}
            </Grid>
            {!props.hideAction && (
                <Grid item xs={1} xl={1} sm={1} md={1} lg={1} className={clsx(classes.alignCenter)}>
                    {isSingle ? (
                        <Radio
                            checked={isActive}
                            style={{ paddingLeft: 0, paddingRight: 0 }}
                            classes={{
                                checked: classes.radioChecked,
                            }}
                        />
                    ) : (
                        <Checkbox
                            style={{ paddingLeft: 0, paddingRight: 0 }}
                            checked={isActive}
                            disableRipple={true}
                            checkedIcon={<CheckedIcon />}
                            icon={<UnCheckedIcon />}
                        />
                    )}
                </Grid>
            )}
        </Grid>
    );
};

export const SelectOption = (props: ISelectOption) => {
    return <></>;
};
export const SelectedTag = (props: ISelectedTag) => {
    const classes = useSelectedTagStyles();
    return (
        <div className={`${classes.itemTag}`}>
            <div>{props.item.label.trim()}</div>{' '}
            <CloseTagIcon
                color={themes.palette.common.white}
                onClick={() => {
                    props.handleDeleteItem(props.item.value);
                }}
            />
        </div>
    );
};

interface ISelectValue {
    value: any;
    label: string;
    descriptions?: string[];
}

const SelectMultipleDropDown = ({
    listSelectedValue,
    onChange,
    children,
    placeholder,
    error,
    anchorId,
    isSingle,
    isSelectedTag,
    disable,
    isBadgeDropdown,
}: ISelectMultipleDropDown) => {
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(false);
    const [listValue, setListValue] = useState<ISelectValue[]>([]);
    const [showHeader, setShowHeader] = useState(false);
    const [listValueValid, setListValueValid] = useState(false);
    const listStyledChildren = useMemo(() => {
        const _listValue: ISelectValue[] = [];
        const listChildren = React.Children.map(children, (child, index) => {
            const props = child.props;
            const { value, label, descriptions } = props;
            _listValue.push({
                label,
                value,
                descriptions,
            });

            const isActive = listSelectedValue.indexOf(props.value) !== -1;
            const handleChange = (value: any) => {
                if (isSingle) onChange([value]);
                else {
                    if (!isActive) {
                        onChange([...listSelectedValue, value]);
                    } else {
                        const newValue = [...listSelectedValue];
                        newValue.splice(
                            newValue.findIndex((v) => v === value),
                            1,
                        );
                        onChange(newValue);
                    }
                }
            };
            return isBadgeDropdown ? (
                <StyledSelectBadgeWithDesc
                    isSingle={isSingle}
                    key={'option_' + index}
                    isActive={isActive}
                    {...props}
                    handleChange={(value) => {
                        handleChange(value);
                        isSingle && setIsOpen(false);
                    }}
                />
            ) : (
                <StyledSelectOption
                    isSingle={isSingle}
                    key={'option_' + index}
                    isActive={isActive}
                    {...props}
                    handleChange={(value) => {
                        handleChange(value);
                        isSingle && setIsOpen(false);
                    }}
                />
            );
        });
        setListValue(_listValue);
        return listChildren;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [children, listSelectedValue]);

    useEffect(() => {
        if (isOpen) {
            setShowHeader(true);
        } else {
            const tempListValue = listValue
                .filter((_value) => listSelectedValue.indexOf(_value.value) !== -1)
                .filter((value) => value.value !== undefined && value.value !== null && value.value.trim() !== '')
                .map((v) => v.value.trim());

            if (tempListValue.length === 0) {
                setShowHeader(false);
            }
        }
        //eslint-disable-next-line
    }, [isOpen]);

    useEffect(() => {
        const tempListValue = listValue
            .filter((_value) => listSelectedValue.indexOf(_value.value) !== -1)
            .filter((value) => value.value !== undefined && value.value !== null && value.value.trim() !== '')
            .map((v) => v.value.trim());

        if (tempListValue.length > 0) {
            setShowHeader(true);
            setListValueValid(true);
        } else {
            setListValueValid(false);
        }
        //eslint-disable-next-line
    }, [listValue]);

    const scrollToElement = () => {
        try {
            // if (anchorId)
            //     (document.getElementById(anchorId) as any).scrollIntoView(true);
        } catch (error) {}
    };

    //handle click delete item
    const handleDeleteItem = (value) => {
        if (disable) return;
        const isActive = listSelectedValue.indexOf(value) !== -1;
        if (isSingle) onChange([value]);
        else {
            if (!isActive) {
                onChange([...listSelectedValue, value]);
            } else {
                const newValue = [...listSelectedValue];
                newValue.splice(
                    newValue.findIndex((v) => v === value),
                    1,
                );
                onChange(newValue);
            }
        }
        setIsOpen(true);
    };

    return (
        <ClickAwayListener
            onClickAway={() => {
                setIsOpen(false);
            }}
        >
            <div
                style={{
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    borderBottom: `1px solid ${themes.palette.grey['300']}`,
                    marginTop: '18px',
                    padding: '4px 0px',
                }}
                id={anchorId}
                onClick={(e) => {
                    !disable && setIsOpen((prev) => !prev);
                    scrollToElement();
                }}
            >
                {placeholder && showHeader && (
                    <p
                        style={{
                            color: error && !listValueValid ? 'red' : themes.palette.primary.main,
                            fontSize: '14px',
                            fontWeight: 600,
                            fontFamily: 'PoppinsRegular',
                            position: 'absolute',
                            transform: 'scale(0.9) translateX(-2px)',
                            top: '-14px',
                        }}
                    >
                        {placeholder}
                    </p>
                )}
                {isSelectedTag ? (
                    <div className={`input-select ${classes.inputCheckbox} ${error && classes.inputError}`}>
                        {listValue
                            .filter((_value) => listSelectedValue.indexOf(_value.value) !== -1)
                            .map((v, index) => (
                                <SelectedTag item={v} key={`stag_${index}`} handleDeleteItem={handleDeleteItem} />
                            ))}
                    </div>
                ) : (
                    <input
                        type={'text'}
                        placeholder={!showHeader ? placeholder : ''}
                        className={`input-select ${classes.input} ${error && classes.inputError}`}
                        disabled
                        value={listValue
                            ?.filter((_value) => listSelectedValue.indexOf(_value.value) !== -1)
                            ?.map((v) => v?.label?.trim())
                            .join(' , ')}
                    />
                )}

                {!isSelectedTag ? (
                    isOpen ? (
                        <ArrowUp className={classes.selectIcon} />
                    ) : (
                        <ArrowDown className={classes.selectIcon} />
                    )
                ) : (
                    <></>
                )}

                <div
                    className={clsx(
                        classes.optionWrapperTransition,
                        isOpen && isBadgeDropdown
                            ? classes.optionWrapperBadge
                            : isOpen
                                ? classes.optionWrapper
                                : classes.optionWrapperHide,
                    )}
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                >
                    {listStyledChildren}
                </div>
            </div>
        </ClickAwayListener>
    );
};

export default SelectMultipleDropDown;
